import { useParams, Navigate } from 'react-router-dom'
import { Column } from 'src/shared/components/Semantic/all'
import { RoleHeroSection } from './components/RoleHeroSection'
import { PainPointsSection } from './components/PainPointsSection'
import { SolutionSection } from './components/SolutionSection'
import { ConvincersSection } from './components/ConvincersSection'
import { RoleTestimonialSection } from './components/RoleTestimonialSection'
import { RoleFAQSection } from './components/RoleFAQSection'
import { RoleCTASection } from './components/RoleCTASection'
import { Footer } from 'src/shared/components/Footer'
import { getRoleDataBySlug } from './data'

export const RoleLandingPage = () => {
  const { slug } = useParams<{ slug: string }>()

  const data = slug ? getRoleDataBySlug(slug) : undefined

  // Redirect to home if slug is invalid
  if (!data) {
    return <Navigate to="/" replace />
  }

  return (
    <Column className="relative">
      <RoleHeroSection data={data} />
      <PainPointsSection data={data} />
      <SolutionSection data={data} />
      <ConvincersSection data={data} />
      <RoleTestimonialSection data={data} />
      <RoleFAQSection data={data} />
      <RoleCTASection data={data} />
      <Footer />
    </Column>
  )
}
